<template>
  <div v-bind:class="{ paddingContent: isSidebarShow, nonPaddingContent: !isSidebarShow }">
    <div class="container">
      <div class="breadCrumbsContainer" style="display: flex;" v-if="role=='admin'">
        技能者詳細 - {{ name }}
        <div class="headerBtn" @click="workersList()" style="margin: 0px 0px 0px 20px;">一覧に戻る</div>
      </div>
      <!-- ローディング -->
      <div v-if="getLodingFlg">
        <vue-loading type="cylon" color="#1b7e47" :size="{ width: '150px', height: '150px' }">
        </vue-loading>
        <div style="padding: 0px 0px 30px 0px;" v-if="getLodingFlg">Now loading...</div>
      </div>
      <!-- エラー表示 -->
      <div v-if="getErrorFlg"
       style="padding: 0px 0px 30px 0px; margin: auto;">
        <div　class="errMsg">
          <!-- 取得エラー表示 -->
          <div class="errSpan" style="font-size:x-large;" v-if="getErrorFlg">
            {{errorMessage}}
          </div>
        </div>
      </div>
      <!-- ===================技能者・事業者画面=================== -->
      <div v-if="role!=='admin'">
        <form v-if="!getLodingFlg && !getErrorFlg">
          <!-- 作業者情報 -->
          <div class="group">
            <div class="groupTitle" style="display: flex;">
              作業者情報
            </div>
            <div class="row">
              <div class="col">
                <div class="row">
                  <p class="inputTitle editable">氏名</p>
                  <div class="rowRight">
                    <input class="text large" v-model="detail.name" readonly>
                  </div>
                </div>
                <div class="row">
                  <p class="inputTitle editable">性別</p>
                  <div class="rowRight">
                    <input class="text large" v-model="detail.gender" readonly v-if="detail.gender !== undefined">
                    <input class="text large" value="-" readonly v-else>
                  </div>
                </div>
                <div class="row">
                  <p class="inputTitle editable">郵便番号</p>
                  <div class="rowRight">
                    <input class="text large" v-model="detail.postalCode" readonly v-if="detail.postalCode">
                    <input class="text large" value="-" readonly v-else>
                  </div>
                </div>
                <div class="row">
                  <p class="inputTitle editable">住所</p>
                  <div class="rowRight">
                    <input class="text large" v-model="detail.fullAddress" readonly v-if="detail.fullAddress">
                    <input class="text large" value="-" readonly v-else>
                  </div>
                </div>
                <div class="row">
                  <p class="inputTitle editable">電話番号</p>
                  <div class="rowRight">
                    <input class="text large" v-model="detail.tel" readonly v-if="detail.tel">
                    <input class="text large" value="-" readonly v-else>
                  </div>
                </div>
                <div class="row">
                  <p class="inputTitle editable">ログインID</p>
                  <div class="rowRight">
                    <input class="text large" v-model="detail.loginId" readonly v-if="detail.loginId">
                    <input class="text large" value="-" readonly v-else>
                  </div>
                </div>
                <div class="row">
                  <p class="inputTitle editable">メールアドレス</p>
                  <div class="rowRight">
                    <input class="text large" v-model="detail.email" readonly v-if="detail.email">
                    <input class="text large" value="-" readonly v-else>
                  </div>
                </div>
                <div class="row">
                  <p class="inputTitle editable">CCUS技能者ID</p>
                  <div class="rowRight">
                    <input class="text large" v-model="detail.ccusId" readonly v-if="detail.ccusId">
                    <input class="text large" value="登録なし" readonly v-else>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 保険加入情報 -->
          <div class="group">
            <div class="groupTitle" style="display: flex;">
              保険加入情報
            </div>
            <div class="row">
              <div class="col-sm">
                <div class="row">
                  <p class="inputTitle editable" style="width: 100px;">健康保険</p>
                  <div class="rowDouble">
                    <input class="text double" v-model="detail.healthIns" readonly>
                  </div>
                </div>
                <div class="row">
                  <p class="inputTitle editable" style="width: 100px;">年金保険</p>
                  <div class="rowDouble">
                    <input class="text double" v-model="detail.pensionIns" readonly>
                  </div>
                </div>
                <div class="row">
                  <p class="inputTitle editable" style="width: 100px;">雇用保険</p>
                  <div class="rowDouble">
                    <input class="text double" v-model="detail.employmentIns" readonly>
                  </div>
                </div>
              </div>
              <div class="col-sm">
                <div class="row">
                  <p class="inputTitle editable" style="width: 200px;">建設業退職金共済</p>
                  <div class="rowDouble">
                    <input class="text double" v-model="detail.kentaikyo" readonly>
                  </div>
                </div>
                <div class="row">
                  <p class="inputTitle editable" style="width: 200px;">中小企業退職金共済</p>
                  <div class="rowDouble">
                    <input class="text double" v-model="detail.chutaikyo" readonly>
                  </div>
                </div>
                <div class="row">
                  <p class="inputTitle editable" style="width: 200px;">労災保険</p>
                  <div class="rowDouble">
                    <input class="text double" v-model="detail.workmansCompIns" readonly>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 保有資格情報 -->
          <div class="group">
            <div class="groupTitle" style="display: flex;">
              保有資格情報
            </div>
            <div class="row">
              <div v-if="detail.licenses.length > 0">
                <ul>
                  <li v-for="license in detail.licenses" :key="license.id"
                    style="text-align: left; font-size: 1.25rem">
                    {{ license.licenseName }}
                  </li>
                </ul>
              </div>
            </div>
          </div>

        </form>
      </div>

      <!-- ========================運営管理画面======================== -->
      <div v-if="role=='admin'">
        <form v-if="!getLodingFlg && !getErrorFlg">
          <!-- ユーザー情報 -->
          <div class="group">
            <div class="groupTitle" style="display: flex;">
              ユーザー情報
            </div>

            <div class="row">
              <p class="inputTitle editable">内部ID</p>
              <div class="rowRight">
                <input class="text large" v-model="id" readonly>
              </div>
            </div>
            <div class="row">
              <p class="inputTitle editable">ログインID</p>
              <div class="rowRight">
                <input class="text large" v-model="adminDetail.loginId" readonly>
              </div>
            </div>
            <div class="row">
              <p class="inputTitle editable">メールアドレス</p>
              <div class="rowRight">
                <input class="text large" v-model="adminDetail.email" readonly>
              </div>
            </div>
            <div class="row">
              <p class="inputTitle editable">技能者名</p>
              <div class="rowRight">
                <input class="text large" v-model="adminDetail.name" readonly>
              </div>
            </div>
            <div class="row">
              <p class="inputTitle editable">CCUS ID</p>
              <div class="rowRight">
                <input class="text large" v-model="adminDetail.ccusId" readonly v-if="adminDetail.ccusId">
                <input class="text large" value="登録なし" readonly v-else>
              </div>
            </div>
            <div class="row">
              <p class="inputTitle editable">登録日</p>
              <div class="rowRight">
                <input class="text large" v-model="adminDetail.registrationDate" readonly>
              </div>
            </div>
            <div class="row">
              <button class="edit" @click="accessLog()" type="button">アクセスログ
              </button>
              <button class="edit" @click="loginLog()" type="button">ログイン履歴
              </button>
            </div>
          </div>

          <div class="group">
            <div class="groupTitle" style="display: flex;">
              所属事業者
            </div>
            <!-- ローディング -->
            <div v-if="postLodingFlg || putLodingFlg || deleteLodingFlg">
              <vue-loading type="cylon" color="#1b7e47" :size="{ width: '150px', height: '150px' }">
              </vue-loading>
              <div style="padding: 0px 0px 30px 0px;" v-if="postLodingFlg">Now registering...</div>
              <div style="padding: 0px 0px 30px 0px;" v-if="putLodingFlg">Now updateing...</div>
              <div style="padding: 0px 0px 30px 0px;" v-if="deleteLodingFlg">Now deleting...</div>
            </div>
            <!-- エラー表示 -->
            <div v-if="postErrorFlg || putErrorFlg || deleteErrorFlg"
             style="padding: 0px 0px 30px 0px; margin: auto;">
              <div　class="errMsg">
                <!-- 登録エラー表示 -->
                <div class="errSpan" style="font-size:x-large;" v-if="postErrorFlg">
                  データの登録中に問題が発生しました。
                </div>
                <!-- 更新エラー表示 -->
                <div class="errSpan" style="font-size:x-large;" v-if="putErrorFlg">
                  データの更新中に問題が発生しました。
                </div>
                <!-- 削除エラー表示 -->
                <div class="errDiv" style="font-size:x-large;" v-if="deleteErrorFlg">
                  データの削除中に問題が発生しました。
                </div>
              </div>
            </div>
            <div class="row">
              <div style="width: 310px;">
                <div class="selectdiv">
                  <select  v-model="adminDetail.selectedCompany">
                    <option value="" selected>所属</option>
                    <option v-for="company in adminDetail.optionCompany"
                    v-bind:value="company.companyId">
                    {{ company.companyName }}
                    </option>
                  </select>
                </div>
              </div>
              <div style="width: 200px;">
                <div class="selectdiv">
                  <select  v-model="adminDetail.selectedMain">
                    <option value="" selected>主たる事業者</option>
                    <option v-for="isPrimary in adminDetail.optionChoice"
                    v-bind:value="isPrimary.id">
                    {{ isPrimary.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div style="width: 150px;">
                <div class="selectdiv">
                  <select  v-model="adminDetail.selectedHead">
                    <option value="" selected>筆頭者</option>
                    <option v-for="isManager in adminDetail.optionChoice"
                    v-bind:value="isManager.id">
                    {{ isManager.name }}
                    </option>
                  </select>
                </div>
              </div>
              <!-- 登録ボタン -->
              <button class="edit" :disabled="processing" @click="companyAdd(id, adminDetail, rows, validationErrMsg)" type="button">＋追加
              </button>
            </div>
            <!-- 入力チェックエラー表示 -->
            <div v-if="validationErrMsg.length > 0" class="row">
              <div　class="errMsg" v-for="error in validationErrMsg">
                <div class="errSpan">{{error}}</div>
              </div>
            </div>
            <div class="row">
              <vue-good-table :columns='columns' :rows='this.rows'>
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field === 'operation'" style="display: flex;">
                    <div class="remove" @click="openDeleteModal(props.formattedRow, selectAffiliation)">削除</div>
                  </span>
                  <span v-else>{{props.formattedRow[props.column.field]}}</span>
                </template>
                <div slot="emptystate">データがありません</div>
              </vue-good-table>
            </div>
          </div>

        </form>
      </div>
    </div>

    <!-- 削除モーダル画面 -->
    <Modal size="delete" @close="closeDeleteModal()" v-if="deleteModal">
      <p class="modalTitle">削除しますか？</p>
      <div style="text-align:left; margin: 0px 30px 0px 30px; font-weight: bold;">
        <p>
          {{selectAffiliation.select.companyName}} の所属事業者情報を削除してもよろしいですか？<br>
          一度削除したデータは復旧出来ませんので、ご了承下さい。
        </p>
      </div>
      <button @click="companyDeleteExecution(id, adminDetail, rows, selectAffiliation, modal)" class="modalYes">削除する</button>
      <button @click="closeDeleteModal()" class="modalNo" style="margin: 50px 0px 0px 30px;">キャンセル</button>
    </Modal>

  </div>
</template>

<script lang='ts'>
import { Component, Vue } from 'vue-property-decorator';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required, email } from 'vee-validate/dist/rules';
import { VueGoodTable } from 'vue-good-table';
import Modal from './BaseModal.vue';
import ApiClient from '../services/ApiClient';
import { VueLoading } from 'vue-loading-template';
import common from '../services/common';

export default {
  title: '技能者詳細',
  name: 'WorkerDetail',
  components: {
    ValidationProvider,
    ValidationObserver,
    VueGoodTable,
    Modal,
    VueLoading,
  },
  props: {
    id: {
      type: String,
      default: '0',
      required: true,
    },
    name: {
      type: String,
      default: '',
      required: true,
    },
  },
  // setup() {
  //   return {
  //   },
  // },
  data() {
    return {
      deleteModal: false,
      selectAffiliation: { select: {}},
      detail: {
        // 作業者情報
        name: '',
        gender: '',
        postalCode: '',
        fullAddress: '',
        tel: '',
        // ep-Managerアカウント情報
        email: '',
        // CCUS登録情報
        ccusId: '',
        ccusNo: '',
        healthIns: '未加入',       // 健康保険
        pensionIns: '未加入',      // 年金保険
        employmentIns : '未加入',  // 雇用保険
        kentaikyo: '未加入',       // 建退共
        chutaikyo: '未加入',       // 中退共
        workmansCompIns: '未加入',    // 労災保険
        // 保険加入情報
        insurance: {
          healthInsStatus: 0,       // 健康保険
          pensionInsStatus: 0,      // 年金保険
          employmentInsStatus : 0,  // 雇用保険
          kentaikyoStatus: 0,       // 建退共
          chutaikyoStatus: 0,       // 中退共
          workmansCompInsStatus: 0,    // 労災保険
        },
        // 保有資格を配列で取得？
        licenses: [],
      },

      adminDetail: {
        // 作業者情報
        internalID: '',
        name: '',
        gender: '',
        postalCode: '',
        fullAddress: '',
        tel: '',
        email: '',
        registrationDate: '',
        // ep-Managerアカウント情報
        loginId: '',
        // CCUS登録情報
        ccusId: '',
        ccusNo: '',

        // 所属事業者選択用
        selectedCompany: '',
        // 事業者リスト取得
        optionCompany: [],
        // 主事業者選択用
        selectedMain: '',
        // 筆頭主選択用
        selectedHead: '',
        // 二択選択用
        optionChoice: [
          {
            id: 1,
            name: 'はい',
          },
          {
            id: 0,
            name: 'いいえ',
          },
        ],
      },

      columns: [
        {
          label: '技能者所属会社情報ID',
          field: 'workerCompanyId',
          hidden: true,
        },
        {
          label: '事業者ID',
          field: 'companyId',
          hidden: true,
        },
        {
          label: '事業者名',
          field: 'companyName',
          sortable: true,
        },
        {
          label: '主たる事業者',
          field: 'isPrimary',
          sortable: false,
          formatFn: this.viewFormat,
        },
        {
          label: '筆頭者',
          field: 'isManager',
          sortable: false,
          formatFn: this.viewFormat,
        },
        {
          label: '',
          field: 'operation',
          sortable: false,
        },
      ],
      rows: [],
      // ローディング
      getLodingFlg: true,     // データ取得時ローディング用フラグ
      getErrorFlg: false,      // データ取得時エラーフラグ
      postLodingFlg: false,    // データ登録時ローディングフラグ
      postErrorFlg: false,     // データ登録時エラーフラグ
      putLodingFlg: false,   　// データ更新時ローディングフラグ
      putErrorFlg: false,      // データ更新時エラーフラグ
      deleteLodingFlg: false,  // データ削除時ローディングフラグ
      deleteErrorFlg: false, // データ削除時エラーフラグ
      processing: false,
      errorMessage: '',
      // 入力チェック
      validationErrFlg: false, // 入力チェックエラーフラグ
      validationErrMsg: [],    // 入力チェックエラーメッセージ用配列
    };
  },
  // 初期処理
  async mounted() {
    try {
      // 技能者詳細情報取得
      await this.getWorker(this.id, this.detail, this.adminDetail, this.role);
      if (this.role !== 'admin') {
        // 技能者保険加入情報取得
        await this.getInsurances();
        // 技能者保有資格情報取得
        await this.getLicenses();
      } else {
        // 事業者リスト取得
        await this.getCompaniesList(this.adminDetail);
        // 技能者所属会社情報取得
        await this.getWorkerCompanies(this.id, this.adminDetail, this.rows);
      }
    } catch (error) {
      this.errorMessage = error.message;
      this.getErrorFlg = true;
    } finally {
      // ローディング非表示
      this.getLodingFlg = false;
    }
  },
  computed: {
    role() {
      return this.$store.getters.session.role;
    },
    isSidebarShow() {
      return this.$store.getters.session.isSidebarShow;
    },
  },
  watch: {
    role() {
      this.$nextTick(() => {
        // 必要であれば処理を書く 現状必要なロジックはない
      });
    },
    isSidebarShow() {
      this.$nextTick(() => {
        // 必要であれば処理を書く 現状必要なロジックはない
      });
    },
  },
  methods: {
    // 事業者リスト取得
    async getCompaniesList(adminDetail) {
      try {
        // 事業者リスト取得API呼出
        const restResourceService = new ApiClient();
        adminDetail.optionCompany = await restResourceService.getCompaniesList();
      } catch (error) {
      this.errorMessage = error.message;
      throw error;
      }
    },
    // 技能者詳細取得
    async getWorker(id, detail, adminDetail, role) {
      try {
        // 技能者詳細取得API呼出
        const restResourceService = new ApiClient();
        const result = await restResourceService.getWorker(id);
        // 日付フォーマット変換
        const registrationDate = common.dateFormat(result.registrationDate);
        if (role !== 'admin') {
          detail.name = result.workerName;
          detail.gender = result.genderName;
          detail.postalCode = result.postalCode;
          detail.fullAddress = result.fullAddress;
          detail.tel = result.tel;
          detail.email = result.email;
          detail.ccusId = result.ccusWorkerId;
          detail.ccusNo = result.ccusSecurityCode;
          detail.loginId = result.userId;
        } else {
          adminDetail.id = result.workerId;
          adminDetail.name = result.workerName;
          detail.name = result.workerName;
          adminDetail.fullAddress = result.fullAddress;
          adminDetail.tel = result.tel;
          adminDetail.email = result.email;
          adminDetail.registrationDate = registrationDate;
          adminDetail.ccusId = result.ccusWorkerId;
          adminDetail.ccusNo = result.ccusSecurityCode;
          adminDetail.loginId = result.userId;
        }
        return;
      } catch (error) {
      this.errorMessage = error.message;
      throw error;
      }
    },


    // 加入保険情報取得
    async getInsurances() {
      try {
      // 加入保険情報取得API呼出
        const restResourceService = new ApiClient();
        this.detail.insurance = await restResourceService.getWorkerInsurances(this.id);
        this.detail.healthIns = this.insCheck(this.detail.insurance.healthInsStatus);
        this.detail.pensionIns = this.insCheck(this.detail.insurance.pensionInsStatus);
        this.detail.employmentIns = this.insCheck(this.detail.insurance.employmentInsStatus);
        this.detail.kentaikyo = this.insCheck(this.detail.insurance.kentaikyoStatus);
        this.detail.chutaikyo = this.insCheck(this.detail.insurance.chutaikyoStatus);
        this.detail.workmansCompIns = this.insCheck(this.detail.insurance.workmansCompInsStatus);
      } catch (error) {
        throw error;
      }
    },
    insCheck(ins) {
      switch (ins) {
        case 0:
          return '未加入';
          break;
        case 1:
          return '加入';
          break;
        case 2:
          return '適用除外';
          break;
        default:
          return '未加入';
          break;
      }
    },
    // 保有資格情報取得
    async getLicenses() {
      try {
      // 保有資格情報取得API呼出
        const restResourceService = new ApiClient();
        this.detail.licenses = await restResourceService.getWorkerLicenses(this.id);
      } catch (error) {
        throw error;
      }
    },
    // 削除押下時処理　技能者所属会社情報削除モーダルを開く
    openDeleteModal(params, selectAffiliation) {
      window.history.pushState(null, null, null);
      window.addEventListener('popstate', this.closeDeleteModal);
      selectAffiliation.select = params;
      this.deleteModal = true;
    },
    // 所属事業者削除モーダルを閉じる
    closeDeleteModal() {
      window.removeEventListener('popstate', this.closeDeleteModal);
      this.deleteModal = false;
    },
    // 所属事業者リスト取得
    async getWorkerCompanies(id, adminDetail, rows) {
      try {
        // 所属事業者リスト取得API呼出
        const restResourceService = new ApiClient();
        const workerCompanies = await restResourceService.getWorkerCompanies(id);
        for (let i = 0; i < workerCompanies.length; i++) {
          const targetCompany = adminDetail.optionCompany.find((company) =>
            company.companyId === workerCompanies[i].companyId,
          );
          workerCompanies[i].companyName = targetCompany.companyName;
        }
        rows.length = 0;
        for (const workerCompanie of workerCompanies) {
          rows.push(workerCompanie);
        }
      } catch (error) {
      this.errorMessage = error.message;
      throw error;
      }
    },
    // 所属事業者追加
    async companyAdd(id, adminDetail, rows, validationErrMsg) {
      await this.startProcessing();
      // ====================入力チェック====================
      // 入力チェックメッセージ初期化
      validationErrMsg.length = 0;
      if (adminDetail.selectedCompany === '' ||
          adminDetail.selectedMain === '' ||
          adminDetail.selectedHead === '') {
          validationErrMsg.push('所属、主たる事業者、筆頭者はどれも必須項目です');
      }
      if (validationErrMsg.length !== 0) {
        return;
      }
      try {
        // バリデーション未実装
        const companyId = adminDetail.selectedCompany;
        const isPrimary = adminDetail.selectedMain;
        const isManager = adminDetail.selectedHead;
        const body = {
          workerId: id,
          companyId,
          isPrimary,
          isManager,
        };
        // 所属事業者登録API呼出
        const restResourceService = new ApiClient();
        await restResourceService.postWorkerCompanies(body);
        this.getWorkerCompanies(id, adminDetail, rows);
      } catch (error) {
        this.errorMessage = error.message;
        await this.endProcessing();
        throw error;
      } finally {
        await this.endProcessing();
      }
    },
    // 所属事業者削除実行
    async companyDeleteExecution(id, adminDetail, rows, selectAffiliation, modal) {
      try {
        await this.startProcessing();
        const body = {
          workerCompanyId: selectAffiliation.select.workerCompanyId,
        };
        // 所属事業者削除API呼出
        const restResourceService = new ApiClient();
        await restResourceService.deleteWorkerCompany(body);
        this.getWorkerCompanies(id, adminDetail, rows);
      } catch (error) {
      this.errorMessage = error.message;
      this.endProcessing();
      throw error;
      } finally {
        this.endProcessing();
        this.closeDeleteModal();
      }
    },
    // アクセスログ
    accessLog() {
      this.$router.push({
        name: 'AccessLog',
        params: {
          id: this.adminDetail.loginId,
        },
      });
    },
    // ログイン履歴
    loginLog() {
      this.$router.push({
        name: 'LoginLog',
        params: {
          id: this.adminDetail.loginId,
        },
      });
    },
    // 表示用フォーマット
    viewFormat(value) {
      const res = value === 1 ? '〇' : '×';
      return res;
    },
    // 技能者一覧画面へ戻る
    workersList() {
      history.back();
    },
    // チャタリング防止
    async startProcessing() {
      this.processing = true;
    },
    async endProcessing() {
      this.processing = false;
    },
  },
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../style/variables.scss";
.selectdiv {
  position: relative;
  float: left;
  min-width: 95%;
}

.selectdiv:after {
  content: '>';
  font: 17px "Consolas", monospace;
  color: #333;
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  transform: rotate(90deg);
  right: 11px;
  top: 18px;
  padding: 0 0 2px;
  border-bottom: 1px solid #999;
  position: absolute;
  pointer-events: none;
}

.selectdiv select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  /* Add some styling */

  display: block;
  width: 100%;
  max-width: 494px;
  height: 45px;
  float: right;
  margin: 5px 0px;
  padding: 0px 20px;
  font-size: 20px;
  line-height: 1.75;
  color: #333;
  background-color: #ffffff;
  background-image: none;
  border: 2px solid #000000;
  border-radius:10px;
  -ms-word-break: normal;
  word-break: normal;
}
.modalTitle {
  margin: 30px auto;
  font-weight: bold;
  font-size: $font-medium;
  color: $font_color;
}
.modalYes {
  background-color: $button-primary;
  color: $active_font_color;
  font-size: $font-medium;
  width: 200px;
  height: 50px;
  padding: 10px, 10px;
  margin-bottom: 20px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  outline: none;
  appearance: none;
  font-weight: bold;
}
.modalNo {
  background-color: $button-danger;
  color: $active_font_color;
  font-size: $font-medium;
  width: 200px;
  height: 50px;
  padding: 10px, 10px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  outline: none;
  appearance: none;
  font-weight: bold;
}
</style>
